import { useSelector as useSelectorOriginal } from 'react-redux';
import { IRootState } from 'src/reducers';

/**
 * React-Reauxのstate取得用フックuseSelectorに型付けをしたもの
 * @param selector どのプロパティを射影するか指定
 * @param equalityFn 等価判定カスタマイズ用
 */
export const useSelector = <TState extends IRootState, TSelected>(
	selector: (state: TState) => TSelected,
	equalityFn?: (left: TSelected, right: TSelected) => boolean
): TSelected => useSelectorOriginal(selector, equalityFn);



// WEBPACK FOOTER //
// ./src/utils/redux.ts